import { RouteDefinition } from "smash-framework/dist/middlewares/apiGatewayProxyRest/interfaces";
import { getResourceFromSrn } from "./srn";

export const mapResourcesAndRoutes = (routes: RouteDefinition[]) => {
    const mapResourceRoutes = {} as { [key: string]: RouteDefinition[] };
    routes.forEach((route) => {
        if (route.scope === 'public') {
            const resource = route.srn ? getResourceFromSrn(route.srn) : getResourceFromSrn(route.request.path);
            if (!resource) {
                return;
            }
            if (!mapResourceRoutes[resource]) {
                mapResourceRoutes[resource] = [];
            }
            mapResourceRoutes[resource].push(route);

            const methodsPriority = {
                get: 1,
                post: 2,
                put: 3,
                delete: 4,
            };
            mapResourceRoutes[resource] = mapResourceRoutes[resource]
                .sort((a: RouteDefinition, b: RouteDefinition) => {
                    return a.request.path.length - b.request.path.length;
                })
                .sort((a: RouteDefinition, b: RouteDefinition) => {
                    const lowercaseA = a.request.method.toLowerCase() as keyof typeof methodsPriority;
                    const lowercaseB = b.request.method.toLowerCase() as keyof typeof methodsPriority;
                    return (methodsPriority[lowercaseA] || 0) - (methodsPriority[lowercaseB] || 0);
                });
        }
    });
    return mapResourceRoutes;
}
